module.exports = __webpack_public_path__ + "static/JumboFOC-min-fcf2cd14bb2d97ffa26b4565876b4da3.jpg";